<template>
    <v-card class="mb-6">
        <v-card-title>{{ props.label }}</v-card-title>
        <v-card-subtitle v-if="props.hint && props.hint !== props.label">{{ props.hint }}</v-card-subtitle>
        <v-card-text>
            <draggable :list="answers"
                       :item-key="((item) => answers.indexOf(item))"
                       handle=".drag-handle">
                <template #item="{element, index}">
                    <v-text-field v-model="answers[index].text"
                                  :label="answers[index].correct ? $t('editor.fields.quiz.correct') : $t('editor.fields.quiz.wrong')"
                                  variant="underlined">
                        <template v-slot:prepend>
                            <v-icon class="drag-handle">mdi-drag-vertical</v-icon>
                        </template>
                        <template v-slot:append-inner>
                            <v-btn-toggle v-model="answers[index].correct" variant="outlined" mandatory>
                                <v-btn color="success"
                                       :title="$t('editor.fields.quiz.mark_correct')"
                                       :value="true">
                                    <v-icon>mdi-check</v-icon>
                                </v-btn>
                                <v-btn color="error"
                                       :title="$t('editor.fields.quiz.mark_wrong')"
                                       :value="false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-btn-toggle>
                        </template>
                        <template v-slot:append>
                            <v-icon @click="removeFromList(index)" :title="$t('common.actions.remove')">mdi-close</v-icon>
                        </template>
                    </v-text-field>

                </template>
            </draggable>
        </v-card-text>
        <v-card-actions>
            <v-btn icon="mdi-plus-circle"
                   :title="$t('editor.fields.list.add_item')"
                   @click="addToList" color="primary"
                   class="mx-auto" />
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    inheritAttrs: false
}
</script>

<script setup>
import {computed} from "vue";
import draggable from "vuedraggable";
// https://www.npmjs.com/package/jsonpath
import jp from "jsonpath";
import {getStoreByName} from "../../utils/storeHelpers";
import {mandatory_props, resolveFieldPath} from "../../utils/editorConfigFieldHelpers";

const props = defineProps(mandatory_props);
const store = getStoreByName(props.storeName);
/**
 * The effective json_path of this field.
 * @see resolveFieldPath() - handles fields inside (repeatable) SubPanels
 */
const jsonPath = computed(() => resolveFieldPath(store, props.json_path));
const answers = computed({
    get() {
        return jp.value(store[props.jsonKey], jsonPath.value);
    },
    set(v) {
        jp.value(store[props.jsonKey], jsonPath.value, v);
    }
});

function addToList() {
    answers.value.push({
        text: null,
        correct: false,
    });
}
function removeFromList(index) {
    answers.value.splice(index, 1);
}
</script>

<style scoped>

</style>